(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["d_title"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const images = document.querySelectorAll('.sp-title-image');

    images.forEach(img => {
      // 画像がすでに読み込まれているか確認
      if (img.complete) {
        applyDynamicWidth(img);
      } else {
        img.onload = function () {
          applyDynamicWidth(img);
        };
      }
    });

    function applyDynamicWidth(img) {
      const naturalWidth = img.naturalWidth;
      const calculatedWidth = (naturalWidth / 700) * 100;
      img.style.width = `calc(${calculatedWidth}vw)`;
    }

});
  } catch(e) { console.error(e); }
})();

})();
